import React, {createContext, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import get from 'lodash.get';
import {fetchLastTransactions, fetchOverview, fetchSignerTransactions} from './Dashboard/dashboardSlice';
import {fetchTransactions} from './Transactions/transactionsSlice';
import {fetchTransaction} from './Transaction/transactionSlice';
import {fetchInfoLinks, loadTranslations, selectConfig, setLocale, setTheme} from './appSlice';
import {fetchSessionInfo} from './Login/userSlice';
import {BROADCAST_CHANNEL_NAME, BROADCAST_MESSAGES} from '../../constants';

export const BroadcastContext = createContext();

export const BroadcastStation = ({children}) => {
    const dispatch = useDispatch();
    const config = useSelector(selectConfig);
    const [broadcasterChannel, setBroadcasterChannel] = useState();
    function onTransactionUpdate(updatedTransactionId) {
        dispatch(fetchLastTransactions());
        dispatch(fetchTransactions());
        dispatch(fetchOverview());
        dispatch(fetchSignerTransactions());
        if (!updatedTransactionId) return;
        dispatch((dispatch, getState) => {
            const currentTransactionId = get(getState(), 'transaction.transaction.id');
            if (currentTransactionId === updatedTransactionId) {
                dispatch(fetchTransaction({
                    params: {packageId: currentTransactionId, skipSetEmptyTransaction: true}
                }));
            }
        });
    }

    function reloadPage() {
        if (window) {
            window.location.reload(true);
        }
    }

    function handleMessage(msg = '') {
        const {type, payload} = typeof msg === 'string' ? {type: msg, payload: undefined} : (msg || {});
        switch (type) {
            case BROADCAST_MESSAGES.TRANSACTIONS_UPDATED:
                onTransactionUpdate(payload?.transactionId);
                break;
            case BROADCAST_MESSAGES.SUBACCAUNT_CHANGED:
            case BROADCAST_MESSAGES.DELEGATION_CHANGED:
                reloadPage();
                break;
            case BROADCAST_MESSAGES.THEME_CHANGED:
                if (payload?.theme) {
                    dispatch(setTheme({theme: payload.theme, shouldSetCookie: false}));
                }
                break;
            case BROADCAST_MESSAGES.LOCALE_CHANGED:
                if (payload?.locale) {
                    dispatch(setLocale({locale: payload.locale, shouldSetCookie: false}));
                    dispatch(loadTranslations());
                    dispatch(fetchInfoLinks());
                }
                break;
            case BROADCAST_MESSAGES.SESSION_UPDATED:
            case BROADCAST_MESSAGES.AVATAR_CHANGED:
                dispatch(fetchSessionInfo());
                break;
            default:
                break;
        }
    }

    const value = {
        broadcasterChannel,
        handleMessage
    };

    async function initBroadcastChannel() {
        const {BroadcastChannel} = await import('broadcast-channel');
        const newBroadcasterChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME(config.VS_ENV));
        newBroadcasterChannel.onmessage = handleMessage;
        setBroadcasterChannel(newBroadcasterChannel);
    }

    useEffect(() => {
        initBroadcastChannel();

        return () => {
            if (broadcasterChannel && broadcasterChannel.close) {
                broadcasterChannel.close();
            }
        };
    }, []);

    return <BroadcastContext.Provider value={value}>{children}</BroadcastContext.Provider>;
};
